var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgInstagram = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.5 19.5C23.5 21.709 21.709 23.5 19.5 23.5L4.5 23.5C2.291 23.5.5 21.709.5 19.5L.5 4.5C.5 2.291 2.291.5 4.5.5L19.5.5C21.709.5 23.5 2.291 23.5 4.5L23.5 19.5 23.5 19.5zM.5 8.5L7.705 8.5M16.2695 8.5L23.5245 8.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5,12 C17.5,15.038 15.037,17.5 12,17.5 C8.963,17.5 6.5,15.038 6.5,12 C6.5,8.962 8.963,6.5 12,6.5 C15.037,6.5 17.5,8.962 17.5,12 L17.5,12 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "21.5 6.5 18.5 6.5 18.5 3.5 21.5 3.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 1L2.5 8.5M4.5.5L4.5 8.5M6.5.5L6.5 8.5"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgInstagram, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/instagram.892c5392.svg";
export { ForwardRef as ReactComponent };